import React,{useEffect,useState} from 'react' 
import { Document, Page, Text, View, StyleSheet,Image} from '@react-pdf/renderer';
// Logo loaded dynamically from company profile
import config from '../../src/config/config';
import defaultLogo from '../assets/zen_logo.png';
const styles = StyleSheet.create({
    page: {
      flexDirection: 'column',
      backgroundColor: '#fff', 
      padding:0,
      position: 'relative',
    },
    // image watermark start
    watermark: {
        position: 'absolute',
        top: '15%',
        left: '0%',
        right:'0%',
        width: '100%',
        height: '70%',
        opacity: 0.2,
        margin:"0 auto",
        display:"flex"
      },
    // image watermark end
    // static style start
    section:{
        margin:10,
        flexGrow:1,
         border:1
    },
    width:{
        width:"33.3%"
    },
    f9:{
        fontSize:9
    },
    f10:{
        fontSize:10
    },
    large:{
        fontSize:15
    },
    bold:{
        fontWeight:"bold"
    },
    right:{
        textAlign:"right"
    },
    center:{
        textAlign:"center"
    },
    top:{
        borderTop:1
    },
    bottom:{
        borderBottomWidth:1,
    },
    bgColor:{
        backgroundColor:"#00a79d",
        color:"#fff",
    },
    alignItems:{
        display:"flex",alignItems:"center"
    },
    brdright:{
        borderRight:1
    },
    brdrclr:{
        borderRightColor:"#fff"
    },
    pad3:{
        padding:3  
    },
    pad5:{
        padding:5
    },
    pad10:{
        padding:10
    },
    w50:{
        width:"50%"
    },
    w100:{
    width:"100%"
    },
    // static style end
    // page content style  start
    head:{
        width:"100%",
        display:"flex",
        flexDirection:"row"
    },
    table: {
        display: 'table'
    },
    
    tableRow: {
        flexDirection: 'row',
    },
    tableCol: {
        width: '12%',
    },
    tableSno:{
        width: '8%',
    },
    tablePro:{
        width:'45%'
    },
    tableCell: {
        margin: 5,
        fontSize: 11.5,
        textAlign: 'center'
    },
    totalCell: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        width:"100%"
    },
    vh:{
        paddingHorizontal:10,
        paddingVertical:5
    }
    // page content style end
});

const Bill = ({ data = {}, companyDetails = null }) => {
  const { API_DOMAIN, subdomain } = config;
  const [companyData, setCompanyData] = useState(companyDetails || {});
  const rowsPerPage = 35; 

  useEffect(() => {
    if (companyDetails && Object.keys(companyDetails).length > 0) {
      setCompanyData(companyDetails);
      return;
    }

    fetch(`${API_DOMAIN}/company.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        search_text: '',
        company_id: subdomain,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((resData) => {
        if (resData?.body?.companies?.[0]) {
          setCompanyData(resData.body.companies[0]);
        } else if (resData?.body?.company) {
          setCompanyData(resData.body.company);
        }
      })
      .catch((error) => {
        console.error('Error fetching company data:', error);
      });
  }, [companyDetails, API_DOMAIN, subdomain]);

  const activeCompany = (companyDetails && Object.keys(companyDetails).length > 0)
    ? companyDetails
    : (companyData && Object.keys(companyData).length > 0 ? companyData : {});

  const customer = data?.customer || {};

  const rawProducts = Array.isArray(data?.products)
    ? data.products
    : Object.keys(data || {})
        .filter((key) => !isNaN(key))
        .map((key) => data[key]);

  const products = rawProducts.map((p, idx) => ({
    id: p.id || idx,
    name: p.name || p.product_name || `Item ${idx + 1}`,
    product_content: p.product_content || p.unit_name || p.unit || '',
    qty: p.qty || 1,
    per_price: p.per_price !== undefined ? p.per_price : p.price || 0,
    total_price: p.total_price !== undefined ? p.total_price : (Number(p.price || 0) * Number(p.qty || 1)).toFixed(2),
    discount_lock: p.discount_lock !== undefined ? p.discount_lock : 1,
    discount: p.discount || 0,
  }));

  const groupedProducts = products.reduce((acc, product) => {
    const groupKey = product.discount_lock === 1 ? 'Net Rate' : (product.discount ? `Discount(${product.discount}%)` : 'Items');
    if (!acc[groupKey]) {
      acc[groupKey] = [];
    }
    acc[groupKey].push(product);
    return acc;
  }, {});

  const productPages = [];
  let currentPage = [];

  Object.keys(groupedProducts).forEach((groupKey) => {
    groupedProducts[groupKey].forEach((item) => {
      if (currentPage.length < rowsPerPage) {
        currentPage.push({ groupKey, item });
      } else {
        productPages.push(currentPage);
        currentPage = [{ groupKey, item }];
      }
    });
  });

  if (currentPage.length) {
    productPages.push(currentPage);
  }
  if (productPages.length === 0) {
    productPages.push([]);
  }

  const subTotalVal = Number(data?.sub_total || 0);
  const pkgChargeVal = Number(data?.package_charge || 0);
  const totalVal = Number(data?.total || subTotalVal + pkgChargeVal);
  const currentdistot = (totalVal - pkgChargeVal).toFixed(2);

  // Use default logo for PDF to guarantee safe rendering across all devices
  const watermarkLogo = defaultLogo;

  return (
    <Document>
      {productPages.map((pageProducts, pageIndex) => (
        <Page key={pageIndex} size="A4" style={styles.page}>
          <Image style={styles.watermark} src={watermarkLogo} />
          <View style={styles.section}>
            <View style={[styles.head, styles.bgColor, styles.alignItems, styles.pad5]}>
              <View style={styles.width}>
                <View style={styles.f9}>
                  <Text>Enquiry No. : {data?.enq || 'ORD'}</Text>
                </View>
              </View>
              <View style={styles.width}>
                <View style={[styles.large, styles.center]}>
                  <Text>Estimation</Text>
                </View>
              </View>
              <View style={styles.width}>
                <View style={[styles.f9, styles.right]}>
                  <Text>Date : {data?.date || new Date().toLocaleDateString()}</Text>
                </View>
              </View>
            </View>

            <View style={[styles.head, styles.f10]}>
              <View style={[styles.w50, styles.brdright, styles.pad5]}>
                <Text style={styles.large}>{activeCompany.company_name || 'Zen Store'}</Text>
                <Text>{activeCompany.address || ''}</Text>
                <Text>Phone : {activeCompany.mobile || activeCompany.phone || '9600653111'}</Text>
              </View>
              <View style={[styles.w50, styles.pad5]}>
                <Text>{customer.name || ''}</Text>
                <Text>{customer.address || ''}</Text>
                <Text>{[customer.city, customer.state].filter(Boolean).join(', ')}</Text>
                {customer.email ? <Text>Email : {customer.email}</Text> : null}
                <Text>Phone : {customer.mobile || ''}</Text>
              </View>
            </View>

            <View style={styles.productTable}>
              <View style={[styles.bgColor, styles.bold]}>
                <View style={[styles.w100, styles.head, styles.table, styles.large]}>
                  <View style={[styles.brdright, styles.brdrclr, styles.tableSno]}>
                    <Text style={styles.tableCell}>S No</Text>
                  </View>
                  <View style={[styles.tablePro, styles.brdright, styles.brdrclr]}>
                    <Text style={styles.tableCell}>Product Name</Text>
                  </View>
                  <View style={[styles.tableCol, styles.brdright, styles.brdrclr]}>
                    <Text style={styles.tableCell}>Content</Text>
                  </View>
                  <View style={[styles.tableCol, styles.brdright, styles.brdrclr]}>
                    <Text style={styles.tableCell}>Qty</Text>
                  </View>
                  <View style={[styles.tableCol, styles.brdright, styles.brdrclr]}>
                    <Text style={styles.tableCell}>Rate</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Amount</Text>
                  </View>
                </View>
              </View>

              {pageProducts.map((product, index) => (
                <React.Fragment key={product.item.id || index}>
                  {index === 0 && (
                    <View style={[styles.tableRow, styles.discountRow]}>
                      <View style={[styles.w100, styles.center]}>
                        <Text style={[styles.center, styles.f9, styles.pad3]}>{product.groupKey}</Text>
                      </View>
                    </View>
                  )}

                  <View style={[styles.tableRow, styles.bottom]} wrap={false}>
                    <View style={styles.tableSno}>
                      <Text style={[styles.center, styles.f9, styles.brdright, styles.pad3]}>{index + 1}</Text>
                    </View>
                    <View style={styles.tablePro}>
                      <Text style={[styles.center, styles.f9, styles.brdright, styles.pad3]}>{product.item.name}</Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={[styles.center, styles.f9, styles.brdright, styles.pad3]}>{product.item.product_content}</Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={[styles.center, styles.f9, styles.brdright, styles.pad3]}>{product.item.qty}</Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={[styles.center, styles.f9, styles.brdright, styles.pad3]}>{product.item.per_price}</Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={[styles.center, styles.f9, styles.pad3]}>{product.item.total_price}</Text>
                    </View>
                  </View>
                </React.Fragment>
              ))}
            </View>
            {pageIndex === productPages.length - 1 && (
              <View style={[styles.totalCell, styles.head, styles.f10, styles.top]}>
                <View style={[styles.w50, styles.brdright, styles.pad5]}>
                  <Text style={styles.large}>Payments Details</Text>
                  {activeCompany.bank_name ? <Text>Bank name : {activeCompany.bank_name}</Text> : null}
                  {activeCompany.acc_holder_name ? <Text>Acc Holder Name : {activeCompany.acc_holder_name}</Text> : null}
                  {activeCompany.ifsc_code ? <Text>IFSC Code: {activeCompany.ifsc_code}</Text> : null}
                  {activeCompany.phone || activeCompany.mobile ? <Text>UPI ID / Phone : {activeCompany.phone || activeCompany.mobile}</Text> : null}
                </View>
                <View style={[styles.totalBox, styles.w50, styles.right]}>
                  <Text style={[styles.bottom, styles.vh]}>Net Total: ₹{subTotalVal.toFixed(2)}</Text>
                  <Text style={[styles.bottom, styles.vh]}>Discount With Total: ₹{currentdistot}</Text>
                  <Text style={[styles.bottom, styles.vh]}>Package Charge: ₹{pkgChargeVal.toFixed(2)}</Text>
                  <Text style={[styles.bottom, styles.vh]}>Total: ₹{totalVal.toFixed(2)}</Text>
                </View>
              </View>
            )}
          </View>
          <View style={[styles.tableRow, styles.discountRow]}>
            <View style={[styles.w100, styles.center]}>
              <Text style={[styles.center, styles.f9, styles.pad3]}>Page {pageIndex + 1} of {productPages.length}</Text>
            </View>
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default Bill;